import React from "react";
import { ReactComponent as TransparentTruck } from "assets/svgs/transparent-truck.svg";
import { ReactComponent as Truck } from "assets/svgs/truck.svg";
import { useGlobalContext } from "context/global";

const FreeShipping = ({ className = "", transparentIcon = false }) => {
	const { translation } = useGlobalContext();

	if (!translation.other?.freeShipping) return null;

	return (
		<div className={`flex text-gray-500 justify-center items-center ${className}`}>
			{transparentIcon ?
				<TransparentTruck role="presentation" aria-hidden="true" /> :
				<Truck className="fill-gray-500" role="presentation" aria-hidden="true" />}
			<span className="ml-2 text-sm md:text-base">{translation.other?.freeShipping}</span>
		</div>
	);
};

export default FreeShipping;